/**
 * @description: 我的藏品详情
 * @info 接口比较乱，修改需谨慎
*/
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router";
import { Toast } from "antd-mobile";
import {
  queryCollectionDetail,
  selRarityList,
  getswitchStatus,
  getMergeSwitchStatus,
  itCanBeSynthesized
} from '@/api/projectManager_self';
import { spaceNiceNoUse, cancelUseSpaceNiceNo, hasSpaceNiceNoUsed } from '@/api/activity';
import { getUrlAllParams, isArray } from "@/utils/publicFun";
import Error from "@/view/Error/index";
import { showLoading, hideLoading } from '@/components/loading';
import NFTHeader from "@/components/NFTHeader";
import confirmModal from "./components/confirmModal";
import submitModal from "./components/submitModal";
import CollectionHeader from './components/collectionHeader';
import {CollectionTitle, CollectionNo, CollectionBenefit, CollectionBenefitForPad} from './components/collectionTitle';
import RarityView from './components/rarityView';
import { CollectorInfo } from './components/collectorInfo';
import CollectionMsg from './components/collectionMsg';
import { TechnologyInfo } from './components/technologyInfo';
import { Footer } from './components/footer';
import "./index.scss";
import appService from "@/utils/appService";
import Service from "@/view/culturalExchange/service";
import JsBridgeNew from "@/utils/jsbridgeNew";

const CodeMap = {
  207: 'healthPreservation', //康养藏品
}

const ratio = window.screen.width / 375;

function MyCollectionDetail() {
  const navigate = useNavigate()
  const { search } = useLocation()
  const { nft_hash = '', isAll = false, clientId = '', userImage = "", nftNo } = getUrlAllParams(search.slice(1));

  const [detailList, setDetailList] = useState(null)
  const [errorContext, seterrorContext] = useState("")
  const [rarityVOS, setRarityVOS] = useState([]);//稀有度的列表
  const [hcStatus, setHcStatus] = useState({status: 0});//合成按钮状态 1可以 其他不行
  const colInfo = useRef({});
  const [spHeChengInfo, setSpHeChengInfo] = useState(false);//碎片是否能合成
  const [gemsCount, setGemsCount] = useState(0) //宝石总数量
  const [gemsFee, setGemsFee] = useState(0) //转赠消耗宝石数
  const pageDom = useRef(null);
  const [culturalData, setCulturalData] = useState({}) // 文交所藏品权益是否领取
  const [activityCode, setActivityCode] = useState(Service.activityCode)
  const [equityData, setEquityData] = useState([]) // 文交所藏品权益是否领取
  const [benefitList, setBenefitList] = useState(null) // 数藏发行平台发行的藏品权益列表，否则不返回此字段
  const [claimFlag, setClaimFlag] = useState(null) // 数藏发行平台发行的才有此字段 权益领取状态（0未领取   1已领取  2部分领取 ）
  const [issuerInfo, setIssuerInfo] = useState() // 发行方信息

  const getCulturalData = async (isRefresh = false) => {
    try {
      isRefresh && showLoading();
      const res = await appService("600926",{
        activityCode: activityCode,
        clientId: clientId,
        nftNo,
      }, false);
      isRefresh && hideLoading();
      setCulturalData(res.data)
      console.log('culturalData==>', res.data)
    } catch (error) {
      isRefresh && hideLoading();
      Toast.show(error);
    }
  }
  const getCulturalData_gold = async (isRefresh = false,nftNo) => {
    try {
      isRefresh && showLoading();
      const res = await appService("600926",{
        activityCode: 'claimNft2',
        clientId: clientId,
        nftNo:nftNo,
      }, false);
      isRefresh && hideLoading();
      setCulturalData(res.data)
      console.log('culturalData==>', res.data)
    } catch (error) {
      isRefresh && hideLoading();
      Toast.show(error);
    }
  }
  const getCulturalData_seasons = async (isRefresh = false,nftNo) => {
    try {
      isRefresh && showLoading();
      const res = await appService("600926",{
        activityCode: 'moutaiCb',
        clientId: clientId,
        nftNo:nftNo,
      }, false);
      isRefresh && hideLoading();
      setCulturalData(res.data)
      console.log('culturalData==>', res.data)
    } catch (error) {
      isRefresh && hideLoading();
      Toast.show(error);
    }
  }
  const getCulturalData_seasons2 = async (isRefresh = false,nftNo) => {
    try {
      isRefresh && showLoading();
      const res = await appService("600926",{
        activityCode: 'moutaiCb2',
        clientId: clientId,
        nftNo:nftNo,
      }, false);
      isRefresh && hideLoading();
      setCulturalData(res.data)
      console.log('culturalData==>', res.data)
    } catch (error) {
      isRefresh && hideLoading();
      Toast.show(error);
    }
  }
  const getCulturalData_onplane = async (isRefresh = false,nftNo) => {
    try {
      isRefresh && showLoading();
      const res = await appService("600926",{
        activityCode: 'airPort',
        clientId: clientId,
        nftNo:nftNo,
      }, false);
      isRefresh && hideLoading();
      setCulturalData(res.data)
      console.log('culturalData==>', res.data)
    } catch (error) {
      isRefresh && hideLoading();
      Toast.show(error);
    }
  }
  const getCulturalData_eurocup = async (isRefresh = false,nftNo) => {
    try {
      isRefresh && showLoading();
      const res = await appService("600926",{
        activityCode: 'UCL2025',
        clientId: clientId,
        nftNo:nftNo,
      }, false);
      isRefresh && hideLoading();
      setCulturalData(res.data)
      console.log('culturalData==>', res.data)
    } catch (error) {
      isRefresh && hideLoading();
      Toast.show(error);
    }
  }
  const getCulturalData_eurocup2 = async (isRefresh = false,nftNo) => {
    try {
      isRefresh && showLoading();
      const res = await appService("600926",{
        activityCode: 'UCL20252nd',
        clientId: clientId,
        nftNo:nftNo,
      }, false);
      isRefresh && hideLoading();
      setCulturalData(res.data)
      console.log('culturalData==>', res.data)
    } catch (error) {
      isRefresh && hideLoading();
      Toast.show(error);
    }
  }
  const getCulturalData_mazu = async (isRefresh = false,nftNo) => {
    try {
      isRefresh && showLoading();
      const res = await appService("600926",{
        activityCode: 'mazu',
        clientId: clientId,
        nftNo:nftNo,
      }, false);
      isRefresh && hideLoading();
      setCulturalData(res.data)
      console.log('culturalData==>', res.data)
    } catch (error) {
      isRefresh && hideLoading();
      Toast.show(error);
    }
  }
  const getCulturalData_greencarbon = async (isRefresh = false,nftNo) => {
    try {
      isRefresh && showLoading();
      const res = await appService("600926",{
        activityCode: 'carbonCredit',
        clientId: clientId,
        nftNo:nftNo,
      }, false);
      isRefresh && hideLoading();
      setCulturalData(res.data)
      console.log('culturalData==>', res.data)
    } catch (error) {
      isRefresh && hideLoading();
      Toast.show(error);
    }
  }

  const getCulturalData_taijigreencarbon = async (isRefresh = false,nftNo) => {
    try {
      isRefresh && showLoading();
      const res = await appService("600926",{
        activityCode: 'TaijiCarbon',
        clientId: clientId,
        nftNo:nftNo,
      }, false);
      isRefresh && hideLoading();
      setCulturalData(res.data)
      console.log('culturalData==>', res.data)
    } catch (error) {
      isRefresh && hideLoading();
      Toast.show(error);
    }
  }
  const dunHuangApe = async (isRefresh = false,nftNo) => {
    try {
      isRefresh && showLoading();
      const res = await appService("600926",{
        activityCode: 'DunHuangApe',
        clientId: clientId,
        nftNo:nftNo,
      }, false);
      isRefresh && hideLoading();
      setCulturalData(res.data)
      console.log('culturalData==>', res.data)
    } catch (error) {
      isRefresh && hideLoading();
      Toast.show(error);
    }
  }
  const getCulturalData_joker = async (isRefresh = false,nftNo) => {
    try {
      isRefresh && showLoading();
      const res = await appService("600926",{
        activityCode: 'pokerApe',
        clientId: clientId,
        nftNo:nftNo,
      }, false);
      isRefresh && hideLoading();
      setCulturalData(res.data)
      console.log('culturalData==>', res.data)
    } catch (error) {
      isRefresh && hideLoading();
      Toast.show(error);
    }
  }
  const getCulturalData_kangyang = async (isRefresh = false,nftNo) => {
    try {
      isRefresh && showLoading();
      const res = await appService("600926",{
        activityCode: 'healthPreBadge',
        clientId: clientId,
        nftNo:nftNo,
      }, false);
      isRefresh && hideLoading();
      setCulturalData(res.data)
      console.log('culturalData==>', res.data)
    } catch (error) {
      isRefresh && hideLoading();
      Toast.show(error);
    }
  }
  const getCulturalData_horseYearInvite = async (isRefresh = false,nftNo) => {
    try {
      isRefresh && showLoading();
      const res = await appService("600926",{
        activityCode: 'horseYearInvite',
        clientId: clientId,
        nftNo:nftNo,
      }, false);
      isRefresh && hideLoading();
      setCulturalData(res.data)
      console.log('culturalData==>', res.data)
    } catch (error) {
      isRefresh && hideLoading();
      Toast.show(error);
    }
  }
  useEffect(() => {
    window.scroll(0, 0);
    window.JsBridge.setTitle("藏品详情");
    if (!nft_hash) {
      Toast.show("参数错误")
      seterrorContext("参数错误")
      return;
    }
    loadData();

  }, []);


  const loadData = ()=> {

    queryDetail().then(() => {
      suiPianHeCheng();
      if(colInfo.current?.collectionId === 207) {
        getMergeSwitchStatusInfo();
      }else {
        getSwitchStatus();
      }
    });
    queryRarityVOS();
  }
  // 藏品权益
  const getEquityData = async (nftNo,activityCode) => {
    const userInfo = await JsBridgeNew.getCurrentUserInfo();
    const res2 = await appService("600114",{
      activityCode: activityCode,
      clientId: userInfo?.clientId,
      collectionId: userInfo?.collectionId,
      nftNo:nftNo,
    }, false);
    console.log('res2===>', res2)
    setEquityData(res2.data)
  }

  const queryDetail = async () => {
    try {
      showLoading();
      const res = await queryCollectionDetail({ nftHash: nft_hash, clientId: (isAll == "true") ? clientId : '' });
      // const res = await mockFn();
      hideLoading();
      if (res.code !== '000000') throw res.msg;
      setGemsFee(res.data?.gemsFee)
      setGemsCount(res.data?.gemsCount)
      setDetailList(res.data.info);
      setBenefitList(res.data.benefitList) // 发行平台发行的才有此字段
      setClaimFlag(res.data.claimFlag) // 发行平台发行的才有此字段
      if(res.data?.issuerName && res.data?.issuerLogo) {
        setIssuerInfo({
          issuerName: res.data.issuerName,
          issuerLogo: res.data.issuerLogo,
        })
      }
      colInfo.current = res.data.info;
      if(nftNo && res?.data.info?.collectionId !== 260 && res.data.info?.seriesId === '19' && res.data.info?.collectionId !== 470) {
        setActivityCode(Service.activityCode)
        await getCulturalData()
      }
      if(res.data.info?.seriesId === '20') {
        setActivityCode('claimNft2')
        await getCulturalData_gold(false,res.data.info?.nftNo)
        await getEquityData(res.data.info?.nftNo,'claimNft2');
      }
      if(res.data.info?.seriesId === '21' && res.data.info?.collectionId !== 275 && res.data.info?.collectionId !== 276 && res.data.info?.collectionId !== 277 && res.data.info?.collectionId !== 278 && res.data.info?.collectionId !== 286){
        // 茅台联名
        setActivityCode('moutaiCb')
        await getCulturalData_seasons(false,res.data.info?.nftNo)
        await getEquityData(res.data.info?.nftNo,'moutaiCb');
      }
      if(res.data.info?.seriesId === '22' && res.data.info?.collectionId === 270){
        // 茅台联名
        setActivityCode('pokerApe')
        await getCulturalData_joker(false,res.data.info?.nftNo)
        await getEquityData(res.data.info?.nftNo,'pokerApe');
      }
      if(res.data.info?.seriesId === '15' && res.data.info?.collectionId === 273){
        // 康养藏品
        setActivityCode('healthPreBadge')
        await getCulturalData_kangyang(false,res.data.info?.nftNo)
        await getEquityData(res.data.info?.nftNo,'healthPreBadge');
      }

      if(res.data.info?.seriesId === '21' && (res.data.info?.collectionId === 276 || res.data.info?.collectionId === 277 || res.data.info?.collectionId === 278)){
        // 茅台联名二期
        setActivityCode('moutaiCb2')
        await getCulturalData_seasons2(false,res.data.info?.nftNo)
        await getEquityData(res.data.info?.nftNo,'moutaiCb2');
      }
      if(res.data.info?.seriesId === '24'){
        // 在飞机上
        setActivityCode('airPort')
        await getCulturalData_onplane(false,res.data.info?.nftNo)
        await getEquityData(res.data.info?.nftNo,'airPort');
      }
      if(res.data.info?.seriesId === '25'){
        if(res.data.info?.collectionId === 288 || res.data.info?.collectionId === 289 || res.data.info?.collectionId === 290 || res.data.info?.collectionId === 291 || res.data.info?.collectionId === 292){
           // 欧冠1期
          setActivityCode('UCL2025')
          await getCulturalData_eurocup(false,res.data.info?.nftNo)
          await getEquityData(res.data.info?.nftNo,'UCL2025');
        }else if(res.data.info?.collectionId === 294 || res.data.info?.collectionId === 295 || res.data.info?.collectionId === 296 || res.data.info?.collectionId === 297 || res.data.info?.collectionId === 298 || res.data.info?.collectionId === 299){
           // 欧冠2期
          setActivityCode('UCL20252nd')
          await getCulturalData_eurocup2(false,res.data.info?.nftNo)
          await getEquityData(res.data.info?.nftNo,'UCL20252nd');
        }
      }
      if(res.data.info?.seriesId === '26'){
        // 妈祖
        setActivityCode('mazu')
        await getCulturalData_mazu(false,res.data.info?.nftNo)
        await getEquityData(res.data.info?.nftNo,'mazu');
      }
        if(res.data.info?.seriesId === '27'&&(res.data.info?.collectionId === 312 || res.data.info?.collectionId === 313)){
          // 绿碳
          setActivityCode('carbonCredit')
          await getCulturalData_greencarbon(false,res.data.info?.nftNo)
          await getEquityData(res.data.info?.nftNo,'carbonCredit');
        }
      if(res.data.info?.seriesId === '28' && (res.data.info?.collectionId === 339 || res.data.info?.collectionId === 340)){
        // 茅台联名二期
        setActivityCode('horseYearInvite')
        await getCulturalData_horseYearInvite(false,res.data.info?.nftNo)
        await getEquityData(res.data.info?.nftNo,'horseYearInvite');
      }
      if(res.data.info?.seriesId === '29'){
        // 藏品购买换积分
        setActivityCode('blindBoxPoint')
        // await getCulturalData_integral(false,res.data.info?.nftNo)
        // await getEquityData(res.data.info?.nftNo,'blindBoxPoint');
      }
      if(res.data.info?.seriesId === '27' && (res.data.info?.collectionId === 348 || res.data.info?.collectionId === 349 || res.data.info?.collectionId === 350 || res.data.info?.collectionId === 351)){
        // 太极碳元
        setActivityCode('TaijiCarbon')
        await getCulturalData_taijigreencarbon(false,res.data.info?.nftNo)
        await getEquityData(res.data.info?.nftNo,'TaijiCarbon');
      }
      if(res.data.info?.seriesId === '1001' && res.data.info?.collectionId === 352) {
        setActivityCode('DunHuangApe')
        await dunHuangApe(false,res.data.info?.nftNo)
        await getEquityData(res.data.info?.nftNo,'DunHuangApe');
      }
      if(res.data.info?.collectionId === 470) {
        setActivityCode('AsianGamesCarbon')
        await getEquityData(res.data.info?.nftNo,'AsianGamesCarbon');
      }
    } catch (error) {
      hideLoading();
      seterrorContext(error);
      Toast.show(error);
    }
  }

  const queryRarityVOS = async () => {
    try {
      showLoading();
      const res = await selRarityList({ nftHash: nft_hash, clientId: (isAll == "true") ? clientId : '' });
      hideLoading();
      if (res.code !== '000000') throw res.msg;
      if (res.data && res.data.rarityVOS && isArray(res.data.rarityVOS) && res.data.rarityVOS.length > 0) {
        setRarityVOS(res.data.rarityVOS)
      }
    } catch (error) {
      hideLoading();
      Toast.show(error);
    }
  }

  const getMergeSwitchStatusInfo = async () => {
    try {
      showLoading();
      const res = await getMergeSwitchStatus({ 
        activityCode: CodeMap[colInfo.current?.collectionId || ''],
        collectionId: colInfo.current?.collectionId || '',
      });
      hideLoading();
      if (res.code !== '000000') throw res.msg;
      setHcStatus({...hcStatus, ...res.data});
    } catch (error) {
      hideLoading();
      Toast.show(error);
    }
  }

  const getSwitchStatus = async () => {
    try {
      showLoading();
      const res = await getswitchStatus({ code: 'COMPOSE' });
      hideLoading();
      if (res.code !== '000000') throw res.msg;
      setHcStatus({...hcStatus, status: res.data});
    } catch (error) {
      hideLoading();
      Toast.show(error);
    }
  }

  const suiPianHeCheng = async () => {
    console.log('colInfo.current---', colInfo.current)
    try {
      const params = {
        petNo: 'debrisSynthesisBefore',
        collectionId: colInfo.current?.collectionId || '',
      }
      const res = await itCanBeSynthesized(params);
      if (res.code !== '000000') throw res.msg;
      setSpHeChengInfo(res.data);
    } catch (error) {
      Toast.show(error);
    }
  }

  const beautifulNumUse = async () => {
    try {
      showLoading()
      const res = await spaceNiceNoUse({
        collectionId: detailList?.collectionId,
        nftNo: detailList?.nftNo,
      })
      hideLoading()
      if (res.code !== '000000') throw res.msg;
      Toast.show({
        content: '使用成功',
        afterClose: async () => {
          await queryDetail();
        }
      });
    } catch (error) {
      hideLoading()
      Toast.show(error)
    }
  }

  const cancelUseBeautifulNum = async () => {
    try {
      showLoading()
      const res = await cancelUseSpaceNiceNo({ spaceNiceNo: detailList?.nftNo })
      hideLoading()
      if (res.code !== '000000') throw res.msg;
      Toast.show({
        content: '取消成功',
        afterClose: async () => {
          await queryDetail();
        }
      });
    } catch (error) {
      hideLoading()
      Toast.show(error)
    }
  }

  const onUseBeautifulNumBtn = async () => {
    if (detailList?.useStatus === 2) {
      return
    }
    if (detailList?.useStatus === 0) {
      try {
        showLoading()
        const res = await hasSpaceNiceNoUsed({
          collectionId: detailList?.collectionId,
          nftNo: detailList?.nftNo,
        })
        hideLoading()
        if (res.code !== '000000') throw res.msg;
        if (res.data.used) {
          replaceBeautifulNum()
        } else {
          if (detailList?.collectionId === 80) {
            inputNumModal()
          } else {
            handleBeautifulNumUse()
          }
        }
      } catch (error) {
        hideLoading()
        Toast.show(error)
      }
    } else if (detailList?.useStatus === 1) {
      cancelUseSpaceNiceNum()
    } else if (detailList?.useStatus === 3) {
      inputNumModal()
    }
  }

  const replaceBeautifulNum = async () => {
    confirmModal({
      pageDom: pageDom.current,
      title: '使用编号',
      content: '同一时间不可叠加使用，确认替换当前编号吗',
      leftBtn: {
        text: '取消',
        onClick: () => {
          console.log('quxiao')
        }
      },
      rightBtn: {
        text: '确认替换',
        onClick: () => {
          beautifulNumUse()
        }
      }
    })
  }

  const cancelUseSpaceNiceNum = () => {
    confirmModal({
      pageDom: pageDom.current,
      title: '取消使用',
      content: '取消使用后编号恢复为原编号',
      leftBtn: {
        text: '取消',
        onClick: () => {
          console.log('quxiao')
        }
      },
      rightBtn: {
        text: '取消使用',
        onClick: () => {
          cancelUseBeautifulNum()
        }
      }
    })
  }

  const handleBeautifulNumUse = () => {
    confirmModal({
      pageDom: pageDom.current,
      title: '使用编号',
      content: '使用后空间id及区块链地址统一为该编号，取消使用/转赠后编号恢复为原编号',
      leftBtn: {
        text: '取消',
        onClick: () => {
          console.log('quxiao')
        }
      },
      rightBtn: {
        text: '确认使用',
        onClick: () => {
          beautifulNumUse()
        }
      }
    })
  }

  const inputNumModal = () => {
    submitModal({
      pageDom: pageDom.current,
      detailInfo: detailList,
      leftBtn: () => console.log('cancel'),
      rightBtn: async () => {
        await queryDetail()
      },
    })
  }

  let styleDistance = { paddingBottom: 12 * ratio * 10 }
  if (isAll == "true") {
    styleDistance = { paddingBottom: 10 }
  }
  var isPick = false;
  if(activityCode === 'TaijiCarbon'){
    isPick = culturalData?.isPick || culturalData?.outPick;
  }else{
    isPick = culturalData?.isPick;
  }

  return (
    <div className="collectioin_detail" ref={pageDom}>
      <NFTHeader midText={'藏品详情'} bgColor={'white'} />
      {!errorContext ? (
        <>
          <CollectionHeader detailList={detailList} />
          <div className="collection-detail-content" style={styleDistance}>
            <CollectionTitle detailList={detailList} issuerInfo={issuerInfo}/>
            {
              rarityVOS.length > 0 && 
              <RarityView rarityVOS={rarityVOS}/>
            }
            <CollectionNo detailList={detailList}/>
            {benefitList?.length > 0 ? <CollectionBenefitForPad benefitList={benefitList} claimFlag={claimFlag} nftNo={nftNo}/> : (
              <>
                {[247,248,249,250,251,252,253,254,255,256,257,258,259].includes(detailList?.collectionId) && <CollectionBenefit isPick={culturalData?.isPick} nftNo={nftNo}/>}
                {detailList?.seriesId === '20'&& <CollectionBenefit equityData={equityData} nftNo={nftNo} isPick={culturalData?.isPick}/>}
                {detailList?.seriesId === '21'&& detailList?.collectionId !== 286 && <CollectionBenefit equityData={equityData} nftNo={nftNo} isPick={culturalData?.isPick} outPick={culturalData?.outPick} seriesId={detailList?.seriesId}/>}
                {detailList?.seriesId === '22'&& detailList?.collectionId === 270 && <CollectionBenefit equityData={equityData} nftNo={nftNo} isPick={culturalData?.isPick}/>}
                {detailList?.seriesId === '15'&& detailList?.collectionId === 273 && <CollectionBenefit equityData={equityData} nftNo={nftNo} isPick={culturalData?.isPick}/>}
                {detailList?.seriesId === '24' && <CollectionBenefit equityData={equityData} nftNo={nftNo} isPick={culturalData?.isPick} seriesId={detailList?.seriesId}/>}
                {detailList?.seriesId === '25' && <CollectionBenefit equityData={equityData} nftNo={nftNo} isPick={culturalData?.isPick} seriesId={detailList?.seriesId}/>}
                {detailList?.seriesId === '26' && <CollectionBenefit equityData={equityData} nftNo={nftNo} isPick={culturalData?.isPick} seriesId={detailList?.seriesId}/>}
                {detailList?.seriesId === '27' && <CollectionBenefit equityData={equityData} nftNo={nftNo} isPick={isPick} seriesId={detailList?.seriesId}/>}
                {detailList?.seriesId === '28'&&(detailList?.collectionId === 339 ||detailList?.collectionId === 340) && <CollectionBenefit equityData={equityData} nftNo={nftNo} isPick={culturalData?.isPick} seriesId={detailList?.seriesId}/>}
              </>
            )}
            {
              isAll == "true" &&
              <CollectorInfo userImage={userImage} detailList={detailList} />
            }
            <CollectionMsg detailList={detailList} />
            {
              !!detailList?.targetNftNo && detailList?.parent == 2 &&
              <div className="technology-message">
                <div className="head" onClick={() => {
                  navigate(`/secondCreationAgreement`)
                }}>
                  <span className="bar">二次创作及商业使用权说明</span>
                  <span className="icon">
                    <img src={require("@/assets/img/collection/goto.png")} alt="avatar" />
                  </span>
                </div>
              </div>
            }
            {
              !(isAll == "true") &&
              <TechnologyInfo detailList={detailList} />
            }
          </div>
          {
            !(isAll === "true") && !(!!detailList && !!detailList?.targetNftNo && detailList?.parent == 2) && (detailList?.collectionId !== 60) &&
            <Footer nft_hash={nft_hash} detailList={detailList}
              spHeChengInfo={spHeChengInfo} hcStatus={hcStatus}
              onRefesh={queryDetail}
              onUseBeautifulNumBtn={onUseBeautifulNumBtn}
              gemsCount={gemsCount}
              gemsFee={gemsFee}
              activityCode={activityCode}
              benefitList={benefitList}
            />
          }
        </>
      ) : (
        <Error context={errorContext} />
      )}
    </div>
  )
}

export default MyCollectionDetail
